"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CountrySelect = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _countryCodes = require("../../../utils/countryCodes");
var _Translated = _interopRequireDefault(require("../../Translated"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const CountrySelect = _ref => {
  let {
    label = /*#__PURE__*/_react.default.createElement(_Translated.default, {
      id: "country"
    }),
    value,
    onChange,
    required: isRequired = true,
    disabled: isDisabled = false
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_core.FormControl, {
    fullWidth: true,
    required: isRequired
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "subtitle1"
  }, label), /*#__PURE__*/_react.default.createElement(_core.Select, {
    value: value,
    onChange: onChange,
    disabled: isDisabled
  }, _countryCodes.countryCodes.map(_ref2 => {
    let {
      isoCountryCode,
      name
    } = _ref2;
    return /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
      key: isoCountryCode,
      value: isoCountryCode
    }, name);
  })));
};
exports.CountrySelect = CountrySelect;